import classNames from 'classnames';
import React from 'react';

import { Arrow } from '@components/common';

import styles from './index.less';

function getDisplayedValue(value, precision = 1) {
  const multiplier = 10 ** precision;
  const mul = Math.round(Math.abs(value) * 100 * multiplier) / multiplier;
  if (mul < 0.001) {
    return ' < 0.001';
  }
  if (mul > 1000) {
    return ' > 1000';
  }
  return `${mul}`;
}

const Trend = ({ value, reverse, className, precision }) => {
  if (typeof value !== 'number') {
    const classString = classNames(styles.trend, className);
    return (
      <div className={classString}>
        <span>-</span>
      </div>
    );
  }

  const flag = value < 0 ? 'down' : 'up';
  const type = (flag === 'up' && !reverse) || (flag === 'down' && reverse) ? 'up' : 'down';

  const classString = classNames(styles[type], styles.trend, className);
  return (
    <div className={classString}>
      <span>{`${getDisplayedValue(value, precision)}%`}</span>
      <Arrow green={type === 'up'} up={value >= 0} />
    </div>
  );
};

Trend.defaultProps = {
  value: '-',
  reverse: false,
  className: '',
  precision: 1,
};

export default Trend;
